import { AxiomReportType } from '@/enums/axiom-report.enum'
import { Stack, Typography } from '@mui/material'
import React from 'react'

export const ValueCard: React.FC<{
  label: string
  displayValue?: string | number | null
  value: string | number | null
  reportType: string
  measurementUnit?: string
}> = ({ label, value, reportType, displayValue }) => {
  return (
    <Stack
      direction='column'
      justifyContent='center'
      alignItems={'center'}
      gap={1}
    >
      <Typography
        variant='h4'
        textAlign='center'
        whiteSpace='nowrap'
        py={4}
        px={8}
        bgcolor={`${reportType === AxiomReportType.GFR ? '#E2F2FE' : Number(value) >= 0 && !Number.isNaN(value) ? '#E8F5E9' : '#F8D7DA'}`}
        width='fit-content'
        borderRadius={1}
        fontWeight='700'
      >
        {displayValue || value}
      </Typography>
      <Typography
        variant='h4'
        textAlign='center'
        whiteSpace='nowrap'
        fontWeight='400'
      >
        {label}
      </Typography>
    </Stack>
  )
}
